module.exports = __webpack_public_path__ + "img/home-bg3.328af4b3.jpg";